<div class="container">
    <div class="row">
        <div class="itinenary-wrapper position-relative">
            <div class="itinenary-wrapper__info__title d-flex d-lg-none">
                <h4 class="primary-title"><strong>{{ selectedCountry.city | titlecase }}</strong></h4>
                <span class="itinenary-wrapper__days">({{selectedCountry.day}} Days)</span>
            </div>
            <button aria-label="Close" type="button" class="btn btn-light map-close btn-close"
                (click)="closeDialog()"></button>

            <div class="itinenary-wrapper__img-box" [@animate]="{value:'*',params:{delay:'5ms',x:'-25px'}}">
                <img src="{{selectedCountry.CorporateTournameImages}}" alt="{{selectedCountry.CorporateTournameImages}}"
                    (error)="handleImageError($event)" loading="lazy">
            </div>

            <div class="itinenary-wrapper__info" [@animate]="{value:'*',params:{delay:'5ms',x:'-25px'}}">

                <ng-container>
                    <div class="itinenary-wrapper__info__title d-lg-block d-none">
                        <h4 class="primary-title"><strong>{{ selectedCountry.city | titlecase }}</strong></h4>
                        <span class="itinenary-wrapper__days">({{selectedCountry.day}} Days)</span>
                    </div>
                    <ul class="itinenary-wrapper__info__list list-unstyled">

                        <li *ngFor="let day of selectedCountry.days">
                            <h5 class="secondary-title">Day {{ day.day }}: {{ day.header }}</h5>

                            <p>{{ day.details }}</p>

                        </li>
                    </ul>
                </ng-container>
            </div>
        </div>

    </div>

</div>